import { i18n } from "app/i18n/i18n";

export function formatCircleDates(events) {
  const lang = i18n.getLanguage();
  events = events.map(parseDates).map(formatDates(lang));
  for (let event of events) {
    event.slots = event.slots.map(parseDates).map(formatDates(lang));
  }
  return events;
}

const parseDates = (event) => ({
  ...event,
  startDateTime: new Date(event.startDateTime),
  endDateTime: new Date(event.endDateTime),
});

const formatDates = (lang) => (event) => ({
  ...event,
  startDateFormatted: event.startDateTime?.toLocaleString(lang, DATE_FORMAT),
  endDateFormatted: event.endDateTime?.toLocaleString(lang, DATE_FORMAT),
  startTimeFormatted: event.startDateTime?.toLocaleString(lang, TIME_FORMAT),
  endTimeFormatted: event.endDateTime?.toLocaleString(lang, TIME_TZ_FORMAT),
});

const DATE_FORMAT = {
  day: "numeric",
  year: "numeric",
  month: "short",
};

const TIME_FORMAT = {
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
};

const TIME_TZ_FORMAT = {
  ...TIME_FORMAT,
  timeZoneName: "short",
};
